import { register } from '@shopify/theme-sections'
import '../../styles/sections/feature-contact.scss'

export default register(`feature-contact`, {
  onLoad() {

  },
  onUnload() {

  },
})
